export default __webpack_public_path__ + "static/unternehmen_2009-b5f17b7ab787101bfc499c5a69bee93c.svg";